module.exports = __webpack_public_path__ + "static/media/kms-image-ori.1549ee22.png";